import Journeys from '@/pages/journeys';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/')({
  component: Journeys,
});
